import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {modalActions, profileActions} from '../../redux/root-action';
import styled from 'styled-components';
import ReactModalContent from '../Shared/Modal/ReactModalContent';
import ReactModalFooter from '../Shared/Modal/ReactModalFooter';
import { modals } from '../../utils/constants';
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import Button from "../Shared/Button";
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import {
    getIsActivationCodeLoaded,
    getIsSubmitActivationCodeLoaded, getIsSubmitActivationCodeRejected,
    getMobileNumber,
    getSelectedPlan
} from "../../redux/profile/selectors";
import {UseAppSelector} from "../../redux/configure-store";
import Input from "../Shared/Input";
import {
    getActivationCode, setIsActivationCodeLoaded,
    setIsSubmitActivationCodeLoaded, setShowSignUpForTextAlertsButton,
    submitActivationCode
} from "../../redux/profile/slice";
import {ProfileBeaconError} from "../Shared/ProfileBeaconComponents";

const StyledCode = styled.div`
  margin-top: 16px;
  font-family:"Nimbus Sans Novus Bold";
  display:flex;
  justify-content:flex-start;
  width:100%;
  @media (max-width: 640px) {
    margin-top: 8px;
  }
`;
const StyledErrorContainer = styled.div`
`;

const StyledError = styled(ProfileBeaconError)`
`;
const StyledText = styled.div`
  margin-top: 16px;
`;

const StyledInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify:content:flex-start;
  margin-left:-12px;
 #activationCode{
 padding-left:0px;}
  input {

    width: 155px;
    height: 40px;
    padding: 0;
    border-radius: 4px;
    border: solid 1px #7c8790;
    margin-right: 8px;
  }
`;
const StyledButton = styled.div`
  margin-left: 8px;
`;


export const SignUpActivationCodeModal = ({modalName,handleCloseModal,dispatchOverlayLoad}) => {
    const dispatch = useDispatch();
    const mobileNumber = UseAppSelector(getMobileNumber);
    const isActivationCodeLoaded = UseAppSelector(getIsActivationCodeLoaded);
    const isSubmitActivationCodeLoaded = UseAppSelector(getIsSubmitActivationCodeLoaded);
    const isSubmitActivationCodeRejected = UseAppSelector(getIsSubmitActivationCodeRejected);
    const selectedPlan = UseAppSelector(getSelectedPlan);
    const planNumber = selectedPlan.value;
    const [isCodeValid, setIsCodeValid] = useState(false);
    const [isSubmitActivationCodeError, setIsSubmitActivationCodeError] = useState(isSubmitActivationCodeRejected);
    const [code, setCode] = useState("");
    const formattedMobileNumber = mobileNumber.replace(/^(\d{3})-(\d{3})-(\d{4})$/, '***-***-$3');
    const handleCodeChange = (event: any) => {
        let value = event.target.value.replace(/\D/g, "");
        value=value.slice(0,6);
        if (value !== code) {
            setIsSubmitActivationCodeError(false);
        }
        setCode(value);
        value.length === 6 ? setIsCodeValid(true) : setIsCodeValid(false)
    }
    const getActivationCodeMethod = useCallback(() => {
        const inputId = document.getElementById("activationCode");
        
        if(inputId){  // THIS sets the value IN the form
            inputId.value = '';    // This sets the value on the prop
        }
        setCode("");
        setIsSubmitActivationCodeError(false);
        dispatch(getActivationCode({mobileNumber,planNumber }));
    },[dispatch]);

    const submitActivationCodeMethod = useCallback(() => {
        setIsSubmitActivationCodeError(false);
        dispatch(submitActivationCode({mobileNumber, planNumber, code }));
    },[dispatch,code]);

    useEffect(() => {
        setIsSubmitActivationCodeError(isSubmitActivationCodeRejected);
    },[isSubmitActivationCodeRejected]);

    useEffect(() => {
        if(isActivationCodeLoaded){
            dispatch(setIsActivationCodeLoaded(false));
        }
    },[isActivationCodeLoaded]);

    useEffect(() => {
        if(isSubmitActivationCodeLoaded){
            handleCloseModal();
            dispatch(setIsSubmitActivationCodeLoaded(false));
            dispatch(setShowSignUpForTextAlertsButton(true));
            dispatch(modalActions.showModal(modals.SIGN_UP_ALL_SET_MODAL));
        }
    },[isSubmitActivationCodeLoaded]);

    useEffect(() => {
        const overlay = "Authentication Code Activation Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const getFooter = () => {
        return  <ReactModalFooter
            tertiaryButtonText={"Cancel"}
            primaryButtonText={"Submit"}
            handleOnClick={() => submitActivationCodeMethod()}
            handleCancelClick={handleCloseModal}
            primaryButtonId = {ANALYTICS_IDS.SignUpModalSubmitBtn}
            tertiaryButtonId={ANALYTICS_IDS.SignUpModalCancelBtn}
            primaryButtonDisabled={!isCodeValid || isSubmitActivationCodeError}
        />
    };
    

    return (
        <React.Fragment>
            <BeaconModal id={modalName}
                         footer={getFooter()}>
                <ReactModalContent>
                    <ReactModalHeader modalTitle="Sign up for text alerts"/>
                    Enter the activation code sent to {formattedMobileNumber}. This one-time code expires 5 minutes after it is sent.

                    <StyledCode>
                        Code
                    </StyledCode>
                    {isSubmitActivationCodeError && <StyledErrorContainer>
                        <StyledError slot='error'>The code you entered is incorrect or expired.</StyledError>
                    </StyledErrorContainer>
                    } 
                    {/* type="number" */}
                    <StyledInputContainer>
                        <Input type="text"  stepper-variant="none"  id="activationCode" onInput={handleCodeChange} format="000000" value={code} isSignUpActivationCodeError={isSubmitActivationCodeError}/>
                        <StyledButton><Button variant="tertiary" onBeaconClick= {() => getActivationCodeMethod()} buttonTitle="Resend Code" /></StyledButton>
                    </StyledInputContainer>
                    <StyledText>
                        When you click submit, you are signing up to receive text alerts.
                    </StyledText>

                </ReactModalContent>
            </BeaconModal>

        </React.Fragment>
    )
}

